import {
  GET_NEW_POST_INIT,
  GET_NEW_POST_SUCCESS,
  GET_NEW_POST_FAILED,
} from "./constants";
export const initialState = {
  loading: false,
  getPosts: {},
  postCount: 20,
  pageCount: 1,
  countPost: 0,
};

export default function getNewPosts(state = initialState, action) {
  switch (action.type) {
    case GET_NEW_POST_INIT:
      return { ...state, loading: true };
    case GET_NEW_POST_SUCCESS:
      let posts;

      if (!state.getPosts.items) {
        posts = action.payload.data;
      } else {
        action.payload.data.items = state.getPosts.items.concat(
          action.payload.data.items
        );
        posts = action.payload.data;
      }

      return {
        ...state,
        loading: false,
        getPosts: posts,
        postCount: action.payload.perPage,
        pageCount: action.payload.page + 1,
        countPost: state.countPost + 20,
      };
    case GET_NEW_POST_FAILED:
      return { ...state, loading: false };
    default:
      return state;
  }
}
